import React from 'react';

import PropTypes from 'prop-types';

import { EmailAddress } from '../../../components/contact-info/email-address';
import { cleanLocationString, cleanedMailToEmailString } from '../helpers';

export const EmailLink = ({ email }) => {
  const cleanEmail = cleanLocationString(email);
  const cleanMailTo = cleanedMailToEmailString(email);
  if (!cleanEmail) {
    return null;
  }
  return <EmailAddress emailAddress={cleanEmail} mailTo={cleanMailTo} />;
};

EmailLink.propTypes = {
  email: PropTypes.string,
};
